import React from 'react'

const Home = () => {
  return (
    <div className="home-section">
  
      <h1>footprint</h1>
      <p>a public project from Hannah & James</p>
   
    </div>
  )
}

export default Home
